import { Component, Input } from '@angular/core';
import { View } from '@ntap/core';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-column-display',
  standalone: true,
  imports: [TooltipModule],
  templateUrl: './column-display.component.html'
})
export class ColumnDisplayComponent {
  @Input() columnName: string = '';
  @Input() view!: View;
  @Input() tableItem: any;
  @Input() lid: any;
}
